<template>
  <v-dialog
      v-model="showLinkBotEditor"
      persistent
      scrollable
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Link BOT</span>
      </v-card-title>
      <v-card-text class="pt-1">
        <v-text-field
            outlined
            prepend-inner-icon="mdi-magnify"
            hide-details
            dense
            class="rounded-lg"
            placeholder="Search by Code or Name"
            flat
            solo
            v-model="search"
        ></v-text-field>
      </v-card-text>
      <v-card-text class="py-0 list-bot" style="height: 300px;">
        <v-list>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">List Bot</v-list-item-title>
              <v-list-item-subtitle>
                <small style="color: red">* Only up to 10 bots can be linked</small>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <span>Select all</span>
              <v-checkbox v-model="isSelectedAll" :indeterminate="isIndeterminate" @change="changeSelectAllItems"/>
            </v-list-item-action>
          </v-list-item>
          <v-list-item class="px-0" v-for="item in filteredItems" :key="item.code" two-line>
            <v-list-item-avatar color="primary" class="white--text font-weight-bold">
              {{$helper.getImageName(item.name) }}
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{item.code}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-checkbox v-model="selectedItems" @change="changeSelectItem" :value="item.code"></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
            depressed
            class="text-none"
            @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
            color="primary"
            depressed
            class="text-none"
            @click="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {sync} from "vuex-pathify";
import {mapActions, mapGetters} from "vuex";
import _ from "lodash"

export default {
  name: "LinkBotEditor",
  data() {
    return {
      isSelectedAll: false,
      selectedItems: [],
    }
  },
  mounted() {
    this.findAll()
  },
  computed: {
    ...mapGetters('bot', ['filteredItems']),
    items: sync('bot/items'),
    showLinkBotEditor: sync('dialogs/showLinkBotEditor'),
    search: sync('bot/search'),
    isIndeterminate() {
      return this.selectedItems.length !== this.filteredItems.length && this.selectedItems.length !== 0
    },
    currentApp: sync('application/currentApp')
  },
  methods: {
    ...mapActions('bot', ['findAll']),
    ...mapActions('application', ['linkBot']),
    submit() {
      const oldLinkedBot = this.currentApp['linked_bots'];
      const oldLinkedBotInSelected = _.filter(oldLinkedBot, o => this.selectedItems.includes(o.bot_code))
      let newLinkBots = _.filter(this.items, o => this.selectedItems.includes(o.code) && !_.some(oldLinkedBotInSelected, {bot_code: o.code}))
      newLinkBots = _.map(newLinkBots, o => {
        return {
          bot_code: o.code,
          bot_name: o.name
        }
      })
      const linkBots =[
          ...oldLinkedBotInSelected,
          ...newLinkBots
      ]
      const data = {
        link_bots: linkBots
      }
      this.linkBot(data)
      this.resetForm()
    },
    cancel() {
      this.resetForm()
    },
    changeSelectItem() {
      this.isSelectedAll = this.selectedItems.length === this.filteredItems.length
    },
    changeSelectAllItems() {
      const _itemsCode = _.map(this.filteredItems, o => o.code)
      if (this.isSelectedAll) {
        this.selectedItems = _.uniq([...this.selectedItems, ..._itemsCode])
      }
      else this.selectedItems = _.difference(this.selectedItems, _itemsCode)
    },
    syncLinkedBot() {
      if (!_.isEmpty(this.currentApp)) {
        const linkedBots = this.currentApp['linked_bots']
        this.selectedItems = _.map(linkedBots, o => o.bot_code)
      }
    },
    resetForm() {
      this.syncLinkedBot()
      this.showLinkBotEditor = false
      this.search = ''
    }
  },
  watch: {
    currentApp: {
      immediate: true,
      deep: true,
      handler() {
        this.syncLinkedBot()
      }
    }
  }
}
</script>

<style scoped>
.list-bot::-webkit-scrollbar {
  display: none;
}
.list-bot {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
</style>
